import styled from 'styled-components';

export const FlashMessage = styled.div`
  margin-botton: 0px;
  .flash-message-notification {
    padding-left: 25%;

    @media only screen and (max-width: 768px) {
      padding-left: 0;
    }
  }
`;
